import React,{useEffect} from 'react';
import './main-layout.scss';
// import { Outlet } from 'react-router-dom';
import Sidebar from '../components/sidebar/Sidebar';
import TopNav from '../components/topnav/TopNav';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {agentbookinghistoryDispatch} from '../reducers/UserReducer'
import HeaderSection from '../components/reusableComponents/HeaderSection';
import { useDispatch } from 'react-redux';
const MainLayout = ({ children }) => {
	const location = useLocation();
	const dispatch = useDispatch();
	console.log(window.location.pathname.split('/')[1]);
	const { bookinghistory, bookinghistoryagent,agentlogin } = useSelector(
		(state) => state.user
	);
	useEffect(() => {
		
		dispatch(agentbookinghistoryDispatch(agentlogin && agentlogin.result.result.id));
	  }, []);
	return (
		<>
			<HeaderSection id={1} />
			<Sidebar />
			<div className='main'>
				<div className='main__content'>
					<TopNav />
					{children}
				</div>
			</div>
		</>
	);
};

export default MainLayout;
